import * as React from 'react';
import { SVGProps } from 'react';

const IconWrenchSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6.625 3.87c-.213-.761-.02-1.611.577-2.21a2.263 2.263 0 0 1 2.191-.58l-1.28 1.28.137 1.39 1.455.2 1.281-1.28A2.26 2.26 0 0 1 8.098 5.41l-.007.007-5.269 5.269a1.066 1.066 0 1 1-1.51-1.51L6.626 3.87Z" />
  </svg>
);
export default IconWrenchSizeXs;
